export const USER_TYPE = Object.freeze({
  MANAGED: 'managed',
  UNMANAGED: 'unmanaged',
});

export const LOGGED_IN_COOKIE = 'btn_logged_in';

export const QUERY_KEY_USER_DATA = 'user-data';
export const MUTATION_KEY_PRETEND_MODE = 'pretend-mode';
export const QUERY_KEY_USER_PROFILE = 'user-profile';
export const QUERY_KEY_SHORTLINKS = 'shortlinks';
export const QUERY_KEY_SHORTLINK_BULK_UPLOADS = 'shortlink-bulk-uploads';
export const QUERY_KEY_SHORTLINK = 'shortlink';
export const QUERY_KEY_TAGS = 'tags';
export const ROWS_PER_PAGE_SHORTLINKS = 'btn_rows_per_page_shortlinks';
export const FILTER_COLS_SHORTLINKS = 'btn_filter_cols_shortlinks';

export const LOCAL_STORAGE_KEY_LANGUAGE = 'lang';

export const CREATOR_CONNECTIONS_GENERAL_LAUNCH =
  'creator_connections_general_launch';
export const ANDROID_APP_LAUNCH = 'android_app_launch';
export const CURATEDBY_LAUNCH_BANNER_2 = 'curatedby_launch_banner_2';
export const GEOLOCATION_BETA_LAUNCH = 'geolocation_beta_launch';
